import React, { Component } from "react";

export default class CourseManagement extends Component {
  render() {
    return (
      <div>
        <div className="container my-5">
          <div className="text-center">
            <h3 className="text-primary text-uppercase">Course management</h3>
            <p>
              Use Presentations or Videos you have or by adding content from web
              URL/ sources. <br />
              Scorm support for industry standards.
            </p>
          </div>

          <div className="row mt-5 course-section">
            <div className="col-md-7 card card-body shadow-sm">
              <div className="row">
                <div className="col-md-3 d-flex justify-content-center align-items-center">
                  <img
                    src="./images/homepage/quiz.png"
                    style={{ width: "100%" }}
                    alt=""
                  />
                </div>
                <div className="col-md-9 d-flex align-items-center">
                  <div>
                    <h4 className="text-primary mb-3">
                      Quiz and Assessment Engine
                    </h4>
                    <p>
                      <span className="icon">
                        <i className="fa fa-question"></i>{" "}
                      </span>
                      Support for a variety of question types.
                    </p>
                    <p>
                      <span className="icon">
                        <i className="fa fa-check"></i>{" "}
                      </span>
                      Assessments which can be assigned for submissions
                    </p>
                    <p className="m-0">
                      <span className="icon">
                        <i className="fa fa-file"></i>{" "}
                      </span>
                      Report engine to collect and analyse performance
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-5"></div>
            <div className="col-5"></div>
            <div className="col-md-7 card card-body shadow-sm mt-3">
              <div className="row">
                <div className="col-md-9 d-flex align-items-center">
                  <div>
                    <h4 className="text-primary mb-3">Learning Path</h4>
                    <p className="m-0">
                      <span className="icon">
                        <i className="fa fa-road"></i>{" "}
                      </span>
                      Decide the path in which the learner should view and
                      attempt the course
                    </p>
                  </div>
                </div>
                <div className="col-md-3 d-flex justify-content-center align-items-center">
                  <img
                    src="./images/homepage/career.png"
                    style={{ width: "100%" }}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-md-7 card card-body shadow-sm mt-3">
              <div className="row">
                <div className="col-md-3 d-flex justify-content-center align-items-center">
                  <img
                    src="./images/homepage/photo.png"
                    style={{ width: "100%" }}
                    alt=""
                  />
                </div>
                <div className="col-md-9 d-flex align-items-center">
                  <div>
                    <h4 className="text-primary mb-3">
                      Gallery and File Management
                    </h4>
                    <p className="m-0">
                      <span className="icon">
                        <i className="fa fa-image"></i>{" "}
                      </span>
                      Manage, organize and use files
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
